import { LOCATION_META } from '../../constants';
import { isDone } from '../../utils';
import { AppointmentCard } from '../AppointmentCard/AppointmentCard';
import s from '../../styles/dashboard.module.css';

// A single location's column of appointment cards.
export function LocationColumn({
  locId,
  data,
  date,
  onToggleCheck,
  onTogglePriority,
  loading,
  staff,
  onAssignStaff,
  onUnassignStaff,
  dragOverId,
  setDragOverId,
  onUploadClick,
  onViewPhotos,
  onNextStep,
  uploadStatuses,
}) {
  const meta   = LOCATION_META[locId] || { name: locId, color: '#c9956a' };
  const appts  = data?.appointments || [];
  const done   = appts.filter(isDone).length;
  const urgent = appts.filter(a => a.priority === 'urgent' && !isDone(a)).length;

  const amount = appts.reduce((sum, a) => {
    const n = parseFloat(String(a.totalAmount || '').replace(/[^0-9.]/g, ''));
    return sum + (Number.isNaN(n) ? 0 : n);
  }, 0);

  return (
    <div className={s.locationCol}>
      <div className={s.locationHeader} style={{ borderBottom: `2px solid ${meta.color}` }}>
        <div>
          <div className={s.locationName} style={{ color: meta.color }}>{meta.name}</div>
          <div className={s.locationMeta}>
            {appts.length} appointments · {done} done {amount > 0 ? <span> · ${amount.toFixed(2)}</span> : null}
            {urgent > 0 && <span className={s.locationUrgentCount}>· {urgent} urgent</span>}
          </div>
        </div>
        <div className={s.locationCount} style={{ color: meta.color }}>{appts.length - done}</div>
      </div>

      <div className={s.locationBody}>
        {loading && <div className={s.locationLoading} style={{ color: meta.color }}>LOADING...</div>}
        {!loading && data?.error && <div className={s.locationError}>Error loading appointments</div>}
        {!loading && !data?.error && appts.length === 0 && <div className={s.locationEmpty}>No appointments this day</div>}
        {!loading && appts.map(appt => (
          <AppointmentCard key={appt.id} appt={appt} date={date}
            onToggleCheck={onToggleCheck} onTogglePriority={onTogglePriority}
            accentColor={meta.color} staff={staff}
            onAssignStaff={onAssignStaff} onUnassignStaff={onUnassignStaff}
            dragOverId={dragOverId} setDragOverId={setDragOverId}
            onUploadClick={onUploadClick}
            onViewPhotos={onViewPhotos}
            onNextStep={onNextStep}
            uploadStatus={uploadStatuses[appt.id] || 'idle'}
          />
        ))}
      </div>
    </div>
  );
}
